module.exports = __webpack_public_path__ + "media/instacart-logo.7892d46f92514783c07f048cd4594cce.svg";